import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Typography,
  TextField,
  InputAdornment,
  Divider,
  Paper,
  Box,
} from '@mui/material';
import { Controller } from 'react-hook-form';

// External Links component for property form
const ExternalLinks = ({ control, errors }) => (
  <Paper sx={{ p: 3, mt: 3 }}>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Внешние ссылки
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Укажите ссылки на объект на внешних платформах
        </Typography>
        <Divider sx={{ my: 2 }} />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          name="dgisLink"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Ссылка на 2ГИС"
              fullWidth
              placeholder="https://2gis.ru/tyumen/..."
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Box component="img" src="/assets/resources_logos/2gis.jpg" alt="2GIS" sx={{ height: 24, width: 'auto' }} />
                  </InputAdornment>
                ),
              }}
              helperText="Ссылка на объект в 2ГИС"
            />
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          name="yandexLink"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Ссылка на Яндекс.Карты"
              fullWidth
              placeholder="https://yandex.ru/maps/..."
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Box component="img" src="/assets/resources_logos/yandex.png" alt="Яндекс" sx={{ height: 24, width: 'auto' }} />
                  </InputAdornment>
                ),
              }}
              helperText="Ссылка на объект в Яндекс.Картах"
            />
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          name="avitoLink"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Ссылка на Авито"
              fullWidth
              placeholder="https://www.avito.ru/..."
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Box component="img" src="/assets/resources_logos/avito.png" alt="Авито" sx={{ height: 24, width: 'auto' }} />
                  </InputAdornment>
                ),
              }}
              helperText="Ссылка на объявление на Авито"
            />
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          name="vkLink"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Ссылка на ВКонтакте"
              fullWidth
              placeholder="https://vk.com/..."
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Box component="img" src="/assets/resources_logos/vk.png" alt="ВКонтакте" sx={{ height: 24, width: 'auto' }} />
                  </InputAdornment>
                ),
              }}
              helperText="Ссылка на группу или страницу ВКонтакте"
            />
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          name="instagramLink"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Ссылка на Instagram"
              fullWidth
              placeholder="https://instagram.com/..."
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Box component="img" src="/assets/resources_logos/insta.png" alt="Instagram" sx={{ height: 24, width: 'auto' }} />
                  </InputAdornment>
                ),
              }}
              helperText="Ссылка на профиль в Instagram"
            />
          )}
        />
      </Grid>
    </Grid>
  </Paper>
);

ExternalLinks.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

export default ExternalLinks;
